(function () {
  var SHOP_CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  var lastCartSig = '';
  var lastRenderedKey = '';
  var lastRenderedHtml = '';
  var inFlight = false;
  var pending = false;
  var lastRunAt = 0;
  var MIN_INTERVAL = 800;

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2);
    var symbol = SHOP_CURRENCY === 'USD' ? '$' : (SHOP_CURRENCY === 'EUR' ? '\u20AC' : (SHOP_CURRENCY + ' '));
    return SHOP_CURRENCY === 'EUR' ? (v + ' ' + symbol) : (symbol + v);
  }

  function renderItem(p) {
    var img = (p.featured_image || '').replace(/(_\w+)\.(jpg|png|webp)/, '_200x.$2');
    return '<div class="cdr-item">'
      + '<a href="' + p.url + '" class="cdr-thumb">'
      + (img ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '')
      + '</a>'
      + '<div class="cdr-info">'
      + '<a href="' + p.url + '" class="cdr-name">' + p.title + '</a>'
      + '<div class="cdr-price">' + formatMoney(p.price) + '</div>'
      + '<button class="cdr-add" type="button" data-cdr-add data-variant-id="' + (p.variants && p.variants[0] ? p.variants[0].id : '') + '">ADD</button>'
      + '</div>'
      + '</div>';
  }

  function findNodes() {
    return { container: document.querySelector('[data-cdr]'), list: document.querySelector('[data-cdr-list]') };
  }

  // Instantly restore the last rendered recs into a freshly-rendered drawer.
  // Called synchronously on MutationObserver -> prevents the flash.
  function restoreCachedRecs() {
    var n = findNodes();
    if (!n.container || !n.list) return false;
    if (!lastRenderedHtml) return false;
    if (n.list.innerHTML) return false; // already populated
    n.list.innerHTML = lastRenderedHtml;
    n.container.hidden = false;
    return true;
  }

  function _doFetch() {
    var n = findNodes();
    if (!n.container || !n.list) return Promise.resolve();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sig = cart.items.map(function (i) { return i.product_id + ':' + i.quantity; }).join(',');
        if (sig === lastCartSig && lastRenderedKey) return;
        lastCartSig = sig;
        if (!cart.items || cart.items.length === 0) {
          var n0 = findNodes();
          if (n0.container) n0.container.hidden = true;
          lastRenderedKey = '';
          lastRenderedHtml = '';
          return;
        }
        var seed = cart.items[0].product_id;
        return fetch('/recommendations/products.json?product_id=' + seed + '&limit=5&intent=related', {
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data.products || [];
            var inCart = {};
            cart.items.forEach(function (it) { inCart[it.product_id] = true; });
            products = products.filter(function (p) { return !inCart[p.id]; }).slice(0, 3);
            var n2 = findNodes();
            if (!n2.container || !n2.list) return;
            if (products.length === 0) {
              n2.container.hidden = true;
              lastRenderedKey = 'empty';
              lastRenderedHtml = '';
              return;
            }
            var renderKey = products.map(function (p) { return p.id; }).join(',');
            if (renderKey === lastRenderedKey && !n2.container.hidden && n2.list.innerHTML) return;
            var html = products.map(renderItem).join('');
            n2.list.innerHTML = html;
            n2.container.hidden = false;
            lastRenderedKey = renderKey;
            lastRenderedHtml = html;
          });
      })
      .catch(function () {
        var n3 = findNodes();
        if (n3.container) n3.container.hidden = true;
      });
  }

  function fetchRecommendations() {
    var now = Date.now();
    if (inFlight) { pending = true; return; }
    if (now - lastRunAt < MIN_INTERVAL) {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; fetchRecommendations(); }, MIN_INTERVAL - (now - lastRunAt));
      return;
    }
    inFlight = true;
    lastRunAt = now;
    _doFetch().finally(function () {
      inFlight = false;
      if (pending) { pending = false; fetchRecommendations(); }
    });
  }

  function handleAdd(e) {
    var btn = e.target.closest('[data-cdr-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (lineItem) {
        lastCartSig = '';
        btn.textContent = '\u2713 ADDED';
        btn.classList.add('cdr-added');
        // Manually fetch the freshly-rendered cart-drawer section and swap its body + summary.
        // Credentials:'include' ensures the cart cookie is sent so items are up to date.
        return fetch('/?section_id=cart-drawer', { credentials: 'include', headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newBody = doc.querySelector('.scd__body');
            var newSummary = doc.querySelector('.scd__summary');
            var currentBody = document.querySelector('#cart-drawer-container .scd__body');
            var currentSummary = document.querySelector('#cart-drawer-container .scd__summary');
            if (newBody && currentBody) currentBody.replaceWith(newBody);
            if (newSummary && currentSummary) currentSummary.replaceWith(newSummary);
            // Notify theme so its internal cart count/badge updates
            var theme = window.spratlyTheme;
            if (theme && theme.Cart && typeof theme.Cart.refreshCart === 'function') {
              try { theme.Cart.refreshCart(); } catch (e) {}
            }
            // Our container observer will detect the new DOM and restore cached recs.
            setTimeout(fetchRecommendations, 300);
          });
      })
      .catch(function (err) {
        console.warn('add to cart failed', err);
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cdr-add]')) handleAdd(e);
  });

  ['cart:refresh', 'cart:updated', 'ajaxProduct:added', 'cart:open'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(fetchRecommendations, 50); });
  });

  // Watch the cart-drawer-container for re-renders and INSTANTLY restore cached recs
  // (runs synchronously so user sees no flash of empty state).
  function initContainerWatcher() {
    var c = document.getElementById('cart-drawer-container');
    if (!c) return false;
    var mo = new MutationObserver(function () {
      // Theme just re-rendered the drawer. Restore cached recs instantly.
      var restored = restoreCachedRecs();
      if (!restored) fetchRecommendations();
      else setTimeout(fetchRecommendations, 300);
    });
    mo.observe(c, { childList: true });
    return true;
  }

  function initDrawerWatcher() {
    var drawer = document.querySelector('.scd__wrapper');
    if (!drawer) return false;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'class' && !drawer.classList.contains('hidden')) {
          fetchRecommendations();
          break;
        }
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    return true;
  }

  function init() {
    fetchRecommendations();
    if (!initContainerWatcher()) setTimeout(initContainerWatcher, 800);
    if (!initDrawerWatcher()) setTimeout(initDrawerWatcher, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
